import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=335804ec&scoped=true&"
import script from "./UpdateAddress.vue?vue&type=script&lang=ts&"
export * from "./UpdateAddress.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateAddress.vue?vue&type=style&index=0&id=335804ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335804ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
